import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../commonv3/api/RemoteResourceV3';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { ReservationListState } from '../../../components/organisms/home/states/ReservationListState';
import { SessionListState } from '../../../components/organisms/sessions/states/SessionListState';
import { LocationApis } from '../../../apis/locations';
import { SheLocation } from '../../../types/location';
import { SubmitState } from '../../../../commonv3/states/SubmitState';
import { SessionTemplate } from '../../../../adminv3/types/session';
import { SessionTemplateApis } from '../../../apis/sessionTemplates';
import { SessionType } from '../../../types/sessions';
import { MembershipPlanGroupKey } from '../../../types/membershipPlans';

export class MokumokuPageState {
  locations: RemoteResourceV3<SheLocation[]> = RemoteResourceV3.loading();
  reservationList: ReservationListState = new ReservationListState();
  sessionList: SessionListState = new SessionListState();
  initState = new SubmitState();
  sessionTemplates: RemoteResourceV3<SessionTemplate[]> = RemoteResourceV3.loading();

  async init() {
    const { currentUser } = GlobalStatesV3;
    await this.initState.operate(async () => {
      await Promise.all([
        this.reloadLocations(),
        currentUser.reloadUser(),
        this.reservationList.init(),
        this.sessionList.init(),
      ]);
    });
  }
  get loading() {
    return this.initState.submitting;
  }

  async reloadLocations() {
    await updateRemoteResourceV3(
      this.locations,
      (v) => (this.locations = v),
      () => LocationApis.findAll()
    );
  }

  async reloadSessionTemplates(sessionType: SessionType, membershipPlanGroupKey: MembershipPlanGroupKey) {
    await updateRemoteResourceV3(
      this.sessionTemplates,
      (v) => (this.sessionTemplates = v),
      () =>
        SessionTemplateApis.findAll({
          session_type: sessionType,
          current_service: membershipPlanGroupKey,
        })
    );
  }
}
